import EmployeePayDetails from './EmployeePayDetails';
import BulkDeductFunds from './BulkDeductFunds';
import PayrollSummary from './PayrollSummary';
import ActionPayroll from './ActionPayroll';
import ReviewPayroll from './ReviewPayroll';
import BulkAddFunds from './BulkAddFunds';
import ViewPayroll from './ViewPayroll';
import Payroll from './Payroll';
import CreatePayroll from './CreatePayroll';
import AddSalesSheet from './AddSalesSheet';

export {
	ActionPayroll,
	CreatePayroll,
	ViewPayroll,
	PayrollSummary,
	EmployeePayDetails,
	Payroll,
	BulkDeductFunds,
	BulkAddFunds,
	ReviewPayroll,
	AddSalesSheet,
};
